import { modals } from 'presentation/main/modals/modals'
import PlanDowngradeAlert from './PlanComparisonV2/PlanDowngradeAlert/PlanDowngradeAlert'

modals.register('PLAN_DOWNGRADE_ALERT_MODAL', PlanDowngradeAlert)
